<template>
    <b-container>
        <b-row v-if="isIntuitApp" class="d4d-decoration">
        </b-row>
        <b-row v-if="isJAApp" class="ja-decoration">
        </b-row>
    
        <b-row class="d4d-login">
                <div class="big-yellow-circle"></div>
                <b-col cols="12" class="mt-1 title">Verify your email</b-col>

                <b-col cols="12" class="mt-3">
                    <p class="text pb-3">Thank you for creating a Design for Delight account.</p>
                    <p class="text">A confirmation email has been sent to your email address.
                         Please click the link in the email to confirm your account at 
                         your earliest convenience.</p>
                </b-col>
                <b-col cols="12" class="mt-2  button-content ">
                    <b-button block variant="primary" :to="{ name: 'Login' }">Continue to Log in</b-button>
                </b-col>
       
        </b-row>
        <legal-message/>
    </b-container>
</template>

<script>
    import LegalMessage from "../Components/LegalMessage"

    export default {
        name: 'verifyEmail',
        components: { LegalMessage }
    }
</script>

<style scoped lang="stylus">
    @import "../Styles/security_styles.styl"
</style>